/**
 * Per-day session state tracker (client-side).
 * Uses localStorage. Not authoritative — good enough to hide intro copy after
 * the first daily visit on this device. Cross-device tracking is a P1 backlog item.
 */

const KEY = "voden_last_dashboard_open";

function todayLocalIso() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function isFirstOpenToday() {
  try {
    const stored = localStorage.getItem(KEY);
    return stored !== todayLocalIso();
  } catch {
    return true;
  }
}

export function markOpenedToday() {
  try {
    localStorage.setItem(KEY, todayLocalIso());
  } catch {
    // ignore quota / privacy mode
  }
}
